import { businessId, clickId, expId } from '@/dataPort/reportId';
import { standardClickReport, standardExpReport } from '@/dataPort/standardReport';

type VerticalSearchReportParam = Record<string, any>;

const withJsonPayload = (eventParam: VerticalSearchReportParam = {}) => ({
  needJSON: true,
  ...eventParam,
});

/** 垂搜：search_button 点击 */
export const reportSearchButtonClick = (eventParam: VerticalSearchReportParam = {}) =>
  standardClickReport(businessId.pageId, clickId.search_button, withJsonPayload(eventParam));

/** 垂搜：search_guide 点击 */
export const reportSearchGuideClick = (eventParam: VerticalSearchReportParam = {}) =>
  standardClickReport(businessId.pageId, clickId.search_guide, withJsonPayload(eventParam));

/** 垂搜：search_add_cart 点击 */
export const reportSearchAddCartClick = (eventParam: VerticalSearchReportParam = {}) =>
  standardClickReport(businessId.pageId, clickId.search_add_cart, withJsonPayload(eventParam));

/** 垂搜：search_product_info 点击 */
export const reportSearchProductInfoClick = (eventParam: VerticalSearchReportParam = {}) =>
  standardClickReport(businessId.pageId, clickId.search_product_info, withJsonPayload(eventParam));

/** 垂搜：search_cable_skuexposure 曝光 */
export const reportSearchCableSkuExposure = (eventParam: VerticalSearchReportParam = {}) =>
  standardExpReport(businessId.pageId, expId.searchlist_cable_skuexposure, withJsonPayload(eventParam));

/** 垂搜：searchlist-result_counts 曝光 */
export const reportSearchResultCountsExposure = (eventParam: VerticalSearchReportParam = {}) =>
  standardExpReport(businessId.pageId, expId.searchlist_result_counts, withJsonPayload(eventParam));
